import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { TooltipProvider } from "@/components/ui/tooltip";

// Handle canonical domain redirects
if (typeof window !== 'undefined') {
  const hostname = window.location.hostname;
  const protocol = window.location.protocol;
  
  // Exclude localhost and preview environments from redirects
  const isLocal = hostname === 'localhost' || hostname === '127.0.0.1';
  const isPreview = hostname.includes('vibepreview.com') || hostname.includes('lovable.app');
  
  if (!isLocal && !isPreview) {
    // Force HTTPS and www
    if (protocol === 'http:' || hostname === 'uplevelcleaning.com') {
      const targetHostname = hostname === 'uplevelcleaning.com' ? 'www.uplevelcleaning.com' : hostname;
      window.location.replace(`https://${targetHostname}${window.location.pathname}${window.location.search}${window.location.hash}`);
    }

    // Register Service Worker for image caching
    if ('serviceWorker' in navigator) {
      window.addEventListener('load', () => {
        navigator.serviceWorker.register('/sw.js').catch(err => {
          console.log('ServiceWorker registration failed: ', err);
        });
      });
    }
  }
}

if ('scrollRestoration' in history) {
  history.scrollRestoration = 'manual';
}

createRoot(document.getElementById("root")!).render(
  <TooltipProvider>
    <App />
  </TooltipProvider>
);

